<template>
  <v-app id="inspire"
         class="FullLayout">
    <template v-if="showAppBar">
      <v-navigation-drawer v-model="drawer"
                           app
                           temporary>
        <v-list dense
                nav>

          <template v-if="canSendEmail">
            <v-list-item v-if="canUseDashboard"
                         :to="{name: `${$root.routePrefix}.user.dashboard`}">
              <v-list-item-icon>
                <v-icon>
                  fal fa-fw fa-tachometer-alt-fast
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  My Dashboard
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="isEmailComposerEnabled === false"
                         :to="{name: `${$root.routePrefix}.email.wizard`}">
              <v-list-item-icon>
                <v-icon>
                  fal fa-fw fa-paper-plane
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Send Email
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="canComposeEmails"
                         :to="{name: `${$root.routePrefix}.send.email`}">
              <v-list-item-icon>
                <v-icon>
                  fal fa-fw fa-paper-plane
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Send Emails
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="canUseSnippets"
                         :to="{name: `${$root.routePrefix}.snippets.index`}">
              <v-list-item-icon>
                <v-icon>
                  fal fa-fw fa-cut
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Email Snippets
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="canUseContacts"
                         :to="{name: `${$root.routePrefix}.user_contacts.index`}">
              <v-list-item-icon>
                <v-icon>
                  fal fa-fw fa-address-book
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Contacts
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <template v-if="canUseCampaign">
              <v-list-item :to="{name: `${$root.routePrefix}.mailcoach.lists`}">
                <v-list-item-icon>
                  <v-icon>
                    fal fa-fw fa-users
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Email Lists
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item :to="{name: `${$root.routePrefix}.mailcoach.campaigns`}">
                <v-list-item-icon>
                  <v-icon>
                    fal fa-fw fa-bullhorn
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Campaigns
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

            </template>

            <v-list-item v-if="canUseSentEmails"
                         :to="{name: `${$root.routePrefix}.mailgun.messages`}">
              <v-list-item-icon>
                <v-icon>
                  fal fa-fw fa-inbox-out
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Sent Emails
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-if="canManageDeviceSessions">
            <v-list-item :to="{name: `${$root.routePrefix}.device_sessions`}">
              <v-list-item-icon>
                <v-icon>
                  fal fa-fw fa-list
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Sessions
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-if="canSendFaxes">
            <v-list-item :to="{name: `${$root.routePrefix}.fax.home`}">
              <v-list-item-icon>
                <v-icon>
                  fal fa-fw fa-fax
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Faxes
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar app
                 flat
                 dense
                 light
                 outlined>
        <v-app-bar-nav-icon @click="drawer = !drawer"
                            color="primary">
        </v-app-bar-nav-icon>

        <div class="d-flex">

          <div class="d-none d-sm-flex">
            <template v-if="canUseDashboard">
              <v-btn :to="{name: `${$root.routePrefix}.user.dashboard`}"
                     text
                     class="mr-1">
                Dashboard
              </v-btn>
            </template>
            <template v-if="canSendEmail">

              <v-btn v-if="isEmailComposerEnabled === false"
                     :to="{name: `${$root.routePrefix}.email.wizard`}"
                     text
                     class="mr-1">
                Send Email
              </v-btn>

              <v-btn v-if="canComposeEmails"
                     :to="{name: `${$root.routePrefix}.send.email`}"
                     text
                     class="mr-1">
                <span>
                  Send Emails
                </span>
                <v-chip v-if="isEmailComposerEnabled === false"
                        color="success"
                        x-small
                        label
                        class="ml-2">
                  NEW
                </v-chip>
              </v-btn>

            </template>

            <template v-if="canUseContacts">
              <v-btn :to="{name: `${$root.routePrefix}.user_contacts.index`}"
                     text
                     class="mr-1">
                Contacts
              </v-btn>
            </template>

            <template v-if="canUseCampaign">
              <v-btn :to="{name: `${$root.routePrefix}.mailcoach.lists`}"
                     text
                     class="mr-1">
                Email Lists
              </v-btn>

              <v-btn :to="{name: `${$root.routePrefix}.mailcoach.campaigns`}"
                     text
                     class="mr-1">
                Campaigns
              </v-btn>
            </template>

            <template v-if="canUseSentEmails">
              <v-btn :to="{name: `${$root.routePrefix}.mailgun.messages`}"
                     text
                     class="mr-1">
                Sent Emails
              </v-btn>
            </template>
          </div>
        </div>
      </v-app-bar>

    </template>
    <v-main>
      <transition name="page"
                  mode="out-in">
        <router-view></router-view>
      </transition>
    </v-main>
    <error-snackbar>
    </error-snackbar>
    <success-snackbar>
    </success-snackbar>
  </v-app>
</template>

<script>
import {mapGetters} from 'vuex'
import AppBar from '../components/AppBar';
import NavigationDrawer from '../components/NavigationDrawer';
import PageFooter from '../components/PageFooter';
import ImpersonatingUser from '../components/ImpersonatingUser';
import ErrorSnackbar from '../components/ErrorSnackbar';
import SuccessSnackbar from '../components/SuccessSnackbar';

export default {
  components: {SuccessSnackbar, ErrorSnackbar, ImpersonatingUser, PageFooter, NavigationDrawer, AppBar},
  data() {
    return {
      // Using null as the starting value for its v-model will initialize the drawer as closed on mobile and as open on desktop.
      drawer: false,
    }
  },
  computed: {
    ...mapGetters([
      'canComposeEmails', // MLD-6403
      'canManageDeviceSessions', // MLD-3922
      'canManageShareTemplates', // MLD-3150
      'canSendEmail', // MLD-3917
      'canSendFaxes', // MLD-3917
      'canUseBuilder', // MLD-2882
      'canUseCampaign', // MLD-3917
      'canUseContacts', // MLD-3922
      'canUseDashboard', // MLD-3922
      'canUseSentEmails', // MLD-3922
      'canUseSnippets', // MLD-3900
      'impersonating', // MLD-3014
      'isAdmin',
      'isCampaignsEnabled', // MLD-3917
      'isEmailComposerEnabled', // MLD-6403
      'isMember',
      'team',
      'user',
    ]),
    userAgent() {
      if (window.navigator && window.navigator.userAgent) {
        return window.navigator.userAgent
      }
      return null;
    },
    showAppBar() {
      return true; // MLD-5687
      //return !(this.userAgent && this.userAgent.toLowerCase().includes('electron'));
    }
  },
}
</script>
